import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    loading_territorial: false,
    loading_track: false,
    loading_channel: false,
    loading_category: false,
    loading_video: false,
    loading: false,
    date_range: [],
    category: [],
    info: [],
    period: [],
    territorial: [],
    track: [],
    channel: [],
    video: [],
    LineChartSett: {
      width: 'auto',
      height: 341,
      is3D: true,
      colors: ['#2e2749', '#e80021'],
      curveType: 'none',
      isStacked: 'relative',
      fontSize: 11,
      fontName: 'Nunito Regular',
      vAxis: {
        minorGridlines: {
          count: 15
        },
        minValue: 0,
        slantedText: true,
        slantedTextAngle: 70,
        gridlines: {
          count: 15
        },
        textStyle: {
          fontSize: 11
        },
        color: '#000',
        format: 'short',
        viewWindowMode: 'pretty'
      },
      hAxis: {
        format: 'short',
        viewWindowMode: 'pretty',
        textStyle: {
          fontSize: 12
        },
        color: '#000'
      },
      tooltip: {
        textStyle: {
          color: '#000',
          fontSize: 16,
          isHtml: true
        },
        showColorCode: true
      },
      lineWidth: 2.3,
      legend: {
        position: 'bottom',
        textStyle: {
          color: '#000',
          fontSize: 14,
          bold: true
        }
      },
      chartArea: {
        left: '7%',
        top: '5%',
        width: '100%',
        height: '75%'
      }
    },
    PieChartSett: {
      width: 'auto',
      height: 330,
      is3D: false,
      pieSliceText: 'value',
      fontName: 'Nunito Bold',
      pieSliceTextStyle: {
        color: '#fff',
        fontSize: 15
      },
      legend: 'none',
      pieHole: 0.5,
      chartArea: {
        width: '90%',
        height: '90%'
      },
      tooltip: {
        textStyle: {
          color: '#000',
          fontSize: 14
        },
        showColorCode: true
      },
      colors: [
        '#FC0000',
        '#FF7F00',
        '#FEE507',
        '#09FB19',
        '#00CC0E',
        '#25A776',
        '#00D5D5',
        '#015C8F',
        '#0606F9',
        '#64289E',
        '#AD0AFC',
        '#F906E1',
        '#B6B0BF',
        '#868292',
        '#605677'
      ]
    },
    ColumnChart: {
      width: 'auto',
      height: 400,
      colors: ['#2e2749', '#554c78', '#a39dbd'],
      fontName: 'Nunito Regular',
      legend: { position: 'bottom', maxLines: 5 },
      bar: { groupWidth: '75%' },
      isStacked: true,
      chartArea: {
        left: '0',
        top: '4%',
        width: '100%',
        height: '70%'
      }
    },
    GeoChartSett: {
      width: 'auto',
      height: 'auto',
      is3D: true,
      fontName: 'Nunito Regular',
      legend: 'none',
      chartArea: {
        right: '0',
        top: '0',
        width: '70%'
      },
      tooltip: {
        textStyle: {
          color: '#000',
          fontSize: 15
        },
        showColorCode: true
      },
      colors: [
        '#F906E1',
        '#AD0AFC',
        '#0606F9',
        '#07F9F9',
        '#09FB19',
        '#FEE507',
        '#FF7F00',
        '#FC0000'
      ]
    }
  },

  mutations: {
    setLoadingTerritorial(state, payload) {
      state.loading_territorial = payload
    },
    setLoadingTrack(state, payload) {
      state.loading_track = payload
    },
    setLoadingChannel(state, payload) {
      state.loading_channel = payload
    },
    setLoadingCategory(state, payload) {
      state.loading_category = payload
    },
    setLoadingVideo(state, payload) {
      state.loading_video = payload
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setDateRange(state, payload) {
      state.date_range = [payload.start, payload.end]
    },
    setCategoryData(state, payload) {
      state.category = payload
    },
    setInfoData(state, payload) {
      state.info = payload
    },
    setInfoPeriodData(state, payload) {
      state.period = payload
    },
    setTerritorialData(state, payload) {
      state.territorial = payload
    },
    setTrackData(state, payload) {
      state.track = payload
    },
    setChannelData(state, payload) {
      state.channel = payload
    },
    setVideoData(state, payload) {
      state.video = payload
    }
  },

  actions: {
    readCategoryData({ commit }) {
      commit('setLoadingCategory', true)
      axios.label
        .get('category')
        .then(r => {
          commit(
            'setCategoryData',
            r.data.data.sort((a, b) => b.video - a.video)
          )
          commit('setLoadingCategory', false)
        })
        .catch(() => {
          commit('setLoadingCategory', false)
        })
    },

    readInfo({ commit }) {
      commit('setLoading', true)
      axios.label
        .get('info')
        .then(r => {
          commit('setInfoData', r.data.data[0])
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },

    readPeriodInfo({ commit }) {
      commit('setLoading', true)
      axios.label
        .get('info/period')
        .then(r => {
          commit('setInfoPeriodData', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },

    readTerritorial({ commit }) {
      commit('setLoadingTerritorial', true)
      axios.label
        .get('territorial')
        .then(r => {
          commit(
            'setTerritorialData',
            r.data.data.sort((a, b) => b.video - a.video)
          )
          commit('setLoadingTerritorial', false)
        })
        .catch(() => {
          commit('setLoadingTerritorial', false)
        })
    },

    readTrack({ commit }, order) {
      commit('setLoadingTrack', true)
      axios.label
        .get('track', {
          params: {
            order_column: order.column,
            order_type: order.type,
            page_size: 5
          }
        })
        .then(r => {
          commit('setTrackData', r.data.data.data)
          commit('setLoadingTrack', false)
        })
        .catch(() => {
          commit('setLoadingTrack', false)
        })
    },

    readTopChannel({ commit }, order) {
      commit('setLoadingChannel', true)
      axios.label
        .get('channel', {
          params: {
            order: order
          }
        })
        .then(r => {
          commit('setChannelData', r.data.data)
          commit('setLoadingChannel', false)
        })
        .catch(() => {
          commit('setLoadingChannel', false)
        })
    },

    readTopVideo({ commit }, order) {
      commit('setLoadingVideo', true)
      axios.label
        .get('video', {
          params: {
            order: order
          }
        })
        .then(r => {
          commit('setVideoData', r.data.data)
          commit('setLoadingVideo', false)
        })
        .catch(() => {
          commit('setLoadingVideo', false)
        })
    }
  },

  getters: {
    category_chart: state => {
      let result = []
      if (state.category.length > 0) {
        result = [['Task', 'Hours per Day']]
        state.category.map(s => {
          result.push([s.category, Number(s.video)])
        })
      }
      return result
    },
    period_chart: state => {
      let views = [['date', 'Views']],
        subscribers = [['date', 'Subscribers']],
        videos = [['date', 'Videos']],
        previews = [['date', 'Previews']],
        result = {}
      if (state.period.length > 0) {
        state.period.map(s => {
          let date = new Date(s.created_at)
          let year = date
            .getFullYear()
            .toString()
            .substr(-2)
          let month = date.toLocaleString('default', { month: 'short' })
          let day = date.getDate().toString()
          let newDate = month + '-' + day + '-' + year
          views.push([newDate, Number(s.views)])
          subscribers.push([newDate, Number(s.subscribers)])
          videos.push([newDate, Number(s.video)])
          previews.push([newDate, Number(s.previews)])
        })
        result = {
          views: views,
          subscribers: subscribers,
          videos: videos,
          previews: previews
        }
        return result
      } else {
        result = {}
        return result
      }
    },
    territorial_chart: state => {
      let result = [['Country', 'Popularity']]
      if (state.territorial.length > 0) {
        state.territorial.map(s => {
          result.push([s.name, Number(s.video)])
        })
      }
      return result
    },
    track_chart: state => {
      let result = []
      if (state.track.length > 0) {
        result = [['Track', 'Views', 'Subscribers', 'Previews']]
        state.track.map(s => {
          result.push([
            s.title,
            Number(s.views),
            Number(s.subscribers),
            Number(s.previews)
          ])
        })
      }
      return result
    }
  }
}

function dateFormat(date) {
  let new_date = new Date(date)
  new_date = new_date
    .toDateString()
    .slice(3, 15)
    .toUpperCase()
  let arr = new_date.split(' ')
  arr = arr.filter(function(str) {
    return /\S/.test(str)
  })
  return arr.join('-')
}
